import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
    return (
        <>
            <footer className="content-footer footer bg-footer-theme">
                <div className="container-xxl">
                    <div className="footer-container d-flex align-items-center justify-content-between py-4 flex-md-row flex-column">

                        <div className="mb-2 mb-md-0">
                           Copyright  &copy; {new Date().getFullYear()}, Cuzysolve. All Rights Reserved
                            {/* <Link to="#" className="footer-link fw-medium">All Rights Reserved</Link> */}
                        </div>

                    </div>
                </div>
            </footer>

        </>
    )
}
